import store from "../store/basic-store";
import {
  CreateGamePayload,
  ZoneId,
  MessagePayload,
  User,
  JsonObj,
  TransportAction,
  TransportSubAction,
} from "../types";
import { wsSend } from "./websocket";

export async function joinGameZoneAction(zone: ZoneId) {
  try {
    await wsSend({
      action: TransportAction.ZONE,
      subAction: TransportSubAction.JOIN,
      payload: { zone },
    });
  } catch (err) {
    // store.setApi({ key: "joinZone", error: (err as Error).message });
    throw new Error("Invalid JOIN_ZONE Action");
  }
}

export async function leaveGameZoneAction(zone: ZoneId, gameId: string) {
  try {
    await wsSend({
      action: TransportAction.ZONE,
      subAction: TransportSubAction.LEAVE,
      payload: { zone, room: gameId },
    });
  } catch (err) {
    // store.setApi({ key: "joinZone", error: (err as Error).message });
    throw new Error("Invalid LEAVE_ZONE Action");
  }
}

export async function sendGameInvite() {
  // {action: 'INVITE_TO_GAME', gameType: string; userId: string}
}

export async function createGame(payload: CreateGamePayload) {
  try {
    await wsSend({
      action: TransportAction.ZONE,
      subAction: TransportSubAction.CREATE,
      payload,
    });
    await getMyGames();
  } catch (err) {
    // store.setApi({ key: "joinZone", error: (err as Error).message });
    throw new Error("Invalid CREATE_GAME Action");
  }
}

export async function getGames(zoneId: ZoneId) {
  try {
    await wsSend({
      action: TransportAction.ZONE,
      subAction: TransportSubAction.GET,
      payload: { zoneId, resource: "games" },
    });
  } catch (err) {
    // store.setApi({ key: "joinZone", error: (err as Error).message });
    throw new Error("Invalid GET_GAMES Action");
  }
}

export async function joinGameAction(id: string, zone: ZoneId) {
  try {
    const user = store.get<User>("user");
    if (user) {
      const sending = await wsSend({
        action: TransportAction.ROOM,
        subAction: TransportSubAction.JOIN,
        payload: { zone, id, userId: user.id },
      });
      await getMyGames();

      return sending;
    }
  } catch (err) {
    // store.setApi({ key: "joinZone", error: (err as Error).message });
    throw new Error("Invalid JOIN_GAME Action");
  }
}

export async function startGame(id: string, zone: ZoneId, options: JsonObj) {
  try {
    const user = store.get<User>("user");
    if (user) {
      return await wsSend({
        action: TransportAction.ROOM,
        subAction: TransportSubAction.START,
        payload: { zone, id, options },
      });
    }
  } catch (err) {
    // store.setApi({ key: "joinZone", error: (err as Error).message });
    throw new Error("Invalid START_GAME Action");
  }
}

export async function getGame(id: string, zone: ZoneId) {
  try {
    await wsSend({
      action: TransportAction.ROOM,
      subAction: TransportSubAction.GET,
      payload: { zone, id },
    });
  } catch (err) {
    throw new Error("Invalid GET_GAME Action");
  }
}

export async function getMyGames() {
  try {
    await wsSend({
      action: TransportAction.USER,
      subAction: TransportSubAction.GET,
      payload: { resource: "games" },
    });
  } catch (err) {
    throw new Error("Invalid GET_MY_GAMES Action");
  }
}

export async function takeTurnAction(
  gameId: string,
  zoneId: ZoneId,
  turn: JsonObj
) {
  try {
    await wsSend({
      action: TransportAction.ROOM,
      subAction: TransportSubAction.TURN,
      payload: { zoneId, gameId, turn },
    });
  } catch (err) {
    throw new Error("Invalid TAKE_TURN Action");
  }
}

export async function forFeitAction(gameId: string, zoneId: ZoneId) {
  try {
    await wsSend({
      action: TransportAction.ROOM,
      subAction: TransportSubAction.FORFEIT,
      payload: { zoneId, gameId },
    });
  } catch (err) {
    throw new Error("Invalid FORFEIT Game Action");
  }
}

export async function sendGameMessageAction(
  gameId: string,
  zoneId: ZoneId,
  message: MessagePayload
) {
  try {
    await wsSend({
      action: TransportAction.ROOM,
      subAction: TransportSubAction.MESSAGE,
      payload: { zoneId, gameId, message },
    });
  } catch (err) {
    throw new Error("Invalid Game MESSAGE Action");
  }
}

export async function getZoneScores() {
  try {
    await wsSend({
      action: TransportAction.USER,
      subAction: TransportSubAction.GET,
      payload: { resource: "scores" },
    });
  } catch (err) {
    throw new Error("Invalid USER_STORE Action");
  }
}
